function initialValues(values, landlord) {
    // console.log( "INITIAL VALUES >>", values );
    return {
        ...values,
        ...initialOccupation(values.occupation),
        ...initialChildren(values.children),
        ...initialArray(values, "gender"),
        ...initialRange(values, "rent"),
        ...initialRange(values, "size"),
        ...initialResidenceType(values.residenceType, landlord),
        ...initialView(values.view)
    }
}


function initialOccupation(occupation) {
    if (!occupation)
        return {};
    const result = {};
    result.occupation = [];
    if (occupation.work) {
        result.occupation.push("work");
        if (occupation.workDetails)
            result.workDetails = occupation.workDetails;
    }
    if (occupation.student) {
        result.occupation.push("student");
        if (occupation.studentDetails)
            result.studentDetails = occupation.studentDetails;
    }
    return result;
}


function initialChildren(children) {
    if (!children)
        return {};
    const result = {};
    result.children = children.map(c => Number(c));
    return result;
}

function initialArray(values, key) {
    const str = values[key];
    if (!str)
        return {};
    let matches;
    if (Array.isArray(str)) {
        matches = str;
    } else if (typeof str === "string") {
        if (str === "{}")
            return {};
        const strRegex = /"[^"]+"/g;
        const captures = str.match(strRegex);
        if (!captures)
            matches = [str];
        else
            matches = captures.map(m => m.substring(1, m.length - 1));
    }
    if (!matches)
        return {};
    const result = {};
    result[key] = [];
    for (let i = 0; i < matches.length; i++) {
        result[key].push(matches[i]);
    }
    return result;
}


function initialRange(values, key) {
    const range = {
        min: values[`${key}Min`],
        max: values[`${key}Max`]
    };
    const result = {};
    result[`${key}Min`] = (typeof range.min === 'string') ? Number(range.min) : range.min;
    result[`${key}Max`] = (typeof range.max === 'string') ? Number(range.max) : range.max;
    return result;
}

function initialResidenceType(residenceType, landlord) {
    // if (landlord)
    //     return {};
    if (!residenceType)
        return {};
    const result = {};
    let obj;
    if (Array.isArray(residenceType))
        // result.residenceType = residenceType[0];
        obj = residenceType[0];
    else if (typeof residenceType === "object") {
        // result.residenceType = residenceType;
        obj = residenceType;
    }
    if (typeof obj === "object") {
        Object.keys(obj).forEach(key => {
            if (obj[key] === true)
                result[`residenceType${capitalize(key)}`] = true;
        });
    }
    return result;
}

function initialView(view) {
    if (!view)
        return {};
    const result = {};
    if (typeof view === "string") {
        if (view === "false")
            result.view = false;
        else if (view === "true")
            result.view = true;
    } else if (typeof view === "boolean") {
        result.view = view;
    }
    return result;
}

function capitalize(str) {
    return
}
// translate
function translateValues(values, properties, landlord) {
    const trimmedValues = {};
    Object.keys(values).forEach(key => {
        if (properties.hasOwnProperty(key)) {
            trimmedValues[key] = values[key];
        }
    });
    return {
        ...trimmedValues,
        occupation: translateOccupation(values.occupation, values.workDetails, values.studentDetails),
        ...translateChildren(values.children),
        ...translateResidenceType(values, "residenceType", landlord),
        ...translateLocation(values.location),
        ...translateRange(values, "rent"),
        ...translateRange(values, "size"),
        ...translateView(values.view)
    }
}

function translateOccupation(occupation, workDetails, studentDetails) {
    if (!occupation)
        return {};
    if (occupation.length === 0)
        return {};
    const result = {};
    if (occupation.includes("work")) {
        result.work = true;
        if (workDetails)
            result.workDetails = workDetails;
    }
    if (occupation.includes("student")) {
        result.student = true;
        if (studentDetails)
            result.studentDetails = studentDetails;
    }
    return result;
}


function translateChildren(children) {
    if (!children)
        return {};
    const result = {};
    result.children = children.map(c => String(c));
    return result;
}


function translateResidenceType(values, key, landlord) {
    if (landlord)
        return {};
    const result = {};
    const types = [
        "apartment",
        "house",
        "room"
    ]
    for (let i = 0; i < types.length; i++) {
        if (values[`${key}${capitalize(types[i])}`])
            result[types[i]] = true;
    }
    if (!Object.keys(result).length)
        return {};
    return {
        [key]: [result]
    };
}

function translateLocation(location) {
    if (!location)
        return {};
    return {
        location: `(${location.lat},${location.lng})`
    }
}

function translateRange(values, key) {
    const range = {
        min: values[`${key}Min`],
        max: values[`${key}Max`]
    };
    const result = {};
    if (range.min === "")
        result[`${key}Min`] = null;
    if (range.max === "")
        result[`${key}Max`] = null;
    return result;
}

function translateView(view) {
    if (!view)
        return {};
    return {
        view: String(view)
    }
}
// users
function translateUserRole(isAdmin, isLandlord) {
    if (isAdmin) {
        return 'Admin'
    }
    if (isLandlord) {
        return 'Landlord'
    }
    return 'Tenant'
}

function translateUserStatus(isMarried) {
    if (isMarried) {
        return 'Married'
    }
    return 'Single'
}

function _translateLanguage(word) {
    switch (word) {
        case 'en':
            return 'English'
        case 'se':
            return 'Swedish'
        case 'fi':
            return 'Finish'
        default:
            return 'Unknown Language'
    }
}

function translateUserLanguage(array) {
    if (!array || array.length < 1) {
        return 'None'
    }
    let languageString = ''
    array.map(item => languageString += `${_translateLanguage(item)}, `)
    return languageString
}

function translateUserBoolean(boolean) {
    if (boolean) {
        return 'Yes'
    }
    return 'No'
}

function initialUserValues(values) {
    return {
        ...values,
        ...initialOccupation(values.occupation)
    }
}
function translateUserChildren(children) {
    if (!children && children !== 0)
        return undefined;
    return Number(children);
}
function translateUserValues(values, selectedUser) {
    const trimmedValues = {};
    Object.keys(values).forEach(key => {
        if (selectedUser.hasOwnProperty(key)) {
            trimmedValues[key] = values[key];
        }
    });

    return {
        ...trimmedValues,
        occupation: translateOccupation(values.occupation, values.workDetails, values.studentDetails),
        children: translateUserChildren(values.children)
    }
}
export {
    initialValues,
    capitalize,
    translateValues,
    initialArray,
    initialView,
    translateLocation,
    translateUserRole,
    translateUserStatus,
    translateUserLanguage,
    translateUserBoolean,
    initialUserValues,
    translateUserValues
}